import { PreventScrolling, ReEnableScrolling } from 'prevent-scrolling';

addEventListener('scroll-lock', () => {
    PreventScrolling();
});

addEventListener('scroll-unlock', () => {
    ReEnableScrolling();
});
